/**
 * useQuestionCommentsQuery - Comentários sociais por questão
 *
 * Encapsula questionCommentsService com cache do React Query. Espelha o padrão
 * de useComments/useAddComment da Comunidade (invalida no sucesso).
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import questionCommentsService from '../../services/questionCommentsService';

export const questionCommentsKeys = {
    all: ['questionComments'],
    byQuestion: (questionId) => [...questionCommentsKeys.all, questionId],
};

/**
 * Buscar comentários de uma questão.
 */
export const useQuestionComments = (questionId, enabled = true) => {
    return useQuery({
        queryKey: questionCommentsKeys.byQuestion(questionId),
        queryFn: () => questionCommentsService.getQuestionComments(questionId),
        staleTime: 1 * 60 * 1000, // 1 minuto
        enabled: enabled && !!questionId,
    });
};

/**
 * Adicionar comentário/resposta a uma questão.
 */
export const useAddQuestionComment = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ questionId, content, parentId }) =>
            questionCommentsService.addQuestionComment(questionId, content, parentId),
        onSuccess: (result, { questionId }) => {
            if (result?.success) {
                queryClient.invalidateQueries({
                    queryKey: questionCommentsKeys.byQuestion(questionId),
                });
            }
        },
    });
};
